import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useGetCompanyByIdQuery, useUpdateCompanyByIdMutation } from "../../../../../API/authApi";
import { IFinancesForm } from "../../../../../Interfaces/formValue-interfaces";
import { useDirectoriesHook, useToastify } from "../../../../../Hooks/hooks";
import useLanguagesHooks from "../../../../../Components/Languages/setLanguage-hooks";
import { IUpdateCompanyById } from "../../../../../Interfaces/request-interfaces";
import { CurrencyTypes, IAutocompleteItem } from "../../../../../Interfaces/componentTypes";

const useFinancesHook = (companyId: number) => {
    const { data: businessData, refetch } = useGetCompanyByIdQuery({ id: companyId });
    const { showToastSuccess, showToastError } = useToastify();
    const [update, { isSuccess: isUpdated, isLoading, isError: isUpdateError }] = useUpdateCompanyByIdMutation();
    const { currencies } = useDirectoriesHook();
    const { t } = useLanguagesHooks();
    const {
        register,
        control,
        formState: { errors },
        setValue,
        getValues,
        watch
    } = useForm<IFinancesForm>({ mode: 'all' });
    const [initialValues, setInitialValues] = useState<{ service_fee?: string; cost_currency?: IAutocompleteItem }>({
        service_fee: undefined,
        cost_currency: undefined
    });
    const initCostCurrency = watch('cost_currency');
    const initServiceFee = watch('service_fee');
    const isCurrencyChanged = initialValues.cost_currency
        ? initCostCurrency?.id !== initialValues.cost_currency.id
        : false;
    const isServiceFeeChanged = initialValues.service_fee !== undefined
        ? initServiceFee !== initialValues.service_fee
        : false;

    const isButtonActive = isCurrencyChanged || isServiceFeeChanged;

    const updateFinance = () => {
        const serviceFeeRaw = getValues('service_fee');
        const currencyId = getValues('cost_currency')?.id as CurrencyTypes;
        const payload: IUpdateCompanyById = {
            id: companyId,
            data: {
                cost_currency: currencyId,
                ...(serviceFeeRaw !== undefined && serviceFeeRaw !== null && serviceFeeRaw !== ''
                    ? { service_fee: !isNaN(parseFloat(String(serviceFeeRaw))) ? parseFloat(String(serviceFeeRaw)).toFixed(2) : undefined }
                    : {}),
            } as IUpdateCompanyById['data'],
        };
        update(payload)
    };

    useEffect(() => {
        if (businessData) {
            setInitialValues({
                service_fee: businessData.service_fee,
                cost_currency: currencies.find(item => item.id === businessData.cost_currency)
            });

            businessData.service_fee && setValue('service_fee', businessData.service_fee);
            businessData.cost_currency && setValue('cost_currency', currencies.find(item => item.id === businessData.cost_currency)!);
        }
    }, [businessData]);

    useEffect(() => {
        if (isUpdated) {
            refetch();
            showToastSuccess(t('Toast.Success.Common'));
        } else if (isUpdateError) {
            showToastError(t('Error.Common'));
        }
    }, [isUpdated, isUpdateError]);


    return {
        errors,
        control,
        isLoading,
        currencies,
        isButtonActive,
        register,
        updateFinance,
    }
};

export default useFinancesHook